export const I18N_KEYS = {
  app: {
    name: 'app.name',
    subtitle: 'app.subtitle',
    loading: 'app.loading',
  },
  nav: {
    menu: 'nav.menu',
    close: 'nav.close',
    admin: 'nav.admin',
    supplier: 'nav.supplier',
    affiliate: 'nav.affiliate',
    niceCall: 'nav.niceCall',
    customer: 'nav.customer',
    cofounder: 'nav.cofounder',
    marketing: 'nav.marketing',
    support: 'nav.support',
  },
  common: {
    back: 'common.back',
    cancel: 'common.cancel',
    confirm: 'common.confirm',
    save: 'common.save',
    search: 'common.search',
    loading: 'common.loading',
    retry: 'common.retry',
    viewDetails: 'common.viewDetails',
  },
  errors: {
    generic: 'errors.generic',
    route: 'errors.route',
    notFound: 'errors.notFound',
  },
  routes: {
    a1: {
      title: 'routes.a1.title',
      eyebrow: 'routes.a1.eyebrow',
      description: 'routes.a1.description',
      sectionTitle: 'routes.a1.sectionTitle',
      sectionBody: 'routes.a1.sectionBody',
    },
    a2: {
      title: 'routes.a2.title',
      eyebrow: 'routes.a2.eyebrow',
      description: 'routes.a2.description',
      sectionTitle: 'routes.a2.sectionTitle',
      sectionBody: 'routes.a2.sectionBody',
    },
    a3: {
      title: 'routes.a3.title',
      eyebrow: 'routes.a3.eyebrow',
      description: 'routes.a3.description',
      sectionTitle: 'routes.a3.sectionTitle',
      sectionBody: 'routes.a3.sectionBody',
    },
    b: {
      title: 'routes.b.title',
      eyebrow: 'routes.b.eyebrow',
      description: 'routes.b.description',
      sectionTitle: 'routes.b.sectionTitle',
      sectionBody: 'routes.b.sectionBody',
    },
    c: {
      title: 'routes.c.title',
      eyebrow: 'routes.c.eyebrow',
      description: 'routes.c.description',
      sectionTitle: 'routes.c.sectionTitle',
      sectionBody: 'routes.c.sectionBody',
    },
    d: {
      title: 'routes.d.title',
      eyebrow: 'routes.d.eyebrow',
      description: 'routes.d.description',
      sectionTitle: 'routes.d.sectionTitle',
      sectionBody: 'routes.d.sectionBody',
    },
    e: {
      title: 'routes.e.title',
      eyebrow: 'routes.e.eyebrow',
      description: 'routes.e.description',
      sectionTitle: 'routes.e.sectionTitle',
      sectionBody: 'routes.e.sectionBody',
    },
  },
} as const
